<template>
  <div class="leveled">
    <div id="componentBox" ref="componentBox">
      <div class="mark">Page1.vue - refactored</div>

      <div class="container relative">
        <div class="row relative">
          <div class="col col-1 no-pad relative">
            <div class="nav-side" :style="getHeightOfApp">
              <div class="btn inactive"></div>
              <router-link
                v-for="(it, ind) in items"
                v-if="ind === 0"
                :key="'a' + it.id"
                :to="{ path: '/tijdslijn/' + it.id }"
                tag="div"
                class="btn next"
              ></router-link>
            </div>
          </div>

          <div class="col col-11 no-pad">
            <!-- Add Class Section -->
            <div class="container bg-white mt-88 relative">
              <div class="row headline-section">
                <div class="col col-1 no-pad"></div>
                <div class="col col-11 no-pad">
                  <h2>Een klas toevoegen</h2>
                  <p>Voeg een klas toe en selecteer per klas een Praktisch of Theoretisch lesprogramma</p>
                </div>
              </div>
            </div>

            <!-- Klassen Overview -->
            <div class="container bg-blue padding-bold">
              <div class="row klas-list">
                <div class="col col-1 no-pad"></div>
                <div class="col col-11 no-pad">
                  <h3>Overzicht klassen</h3>
                  <div class="row no-mar table-head">
                    <div class="col col-5 no-pad">
                      <h6 class="text-white">Klasnaam</h6>
                    </div>
                    <div class="col col-4 no-pad">
                      <h6 class="text-white">Onderwijstype</h6>
                    </div>
                    <div class="col col-3 no-pad"></div>
                  </div>
                </div>
              </div>

              <div class="row klas-list">
                <div class="col col-1 no-pad"></div>
                <div class="col col-11 no-pad">
                  <div
                    class="row no-mar klas-item"
                    v-for="(item, index) in items"
                    :key="item.id"
                  >
                    <div class="col col-5 no-pad">
                      <p
                        :ref="'name' + item.id"
                        class="klas-text"
                        @input="handleInput"
                      >
                        {{ item.title.rendered }}
                      </p>
                    </div>
                    <div class="col col-4 no-pad">
                      <p
                        class="onderwijstype"
                        :class="{ theory: item.onderwijstype === 'theoretisch' }"
                      >
                        {{ item.onderwijstype }}
                      </p>
                    </div>
                    <div class="col col-3 no-pad">
                      <span
                        class="but butt-klas-save"
                        :ref="'save' + item.id"
                        @click="updateItem('name' + item.id, item, 'edit' + item.id,'save' + item.id)"
                      ></span>

                      <span 
                        class="but butt-klas-edit" 
                        :ref="'edit' + item.id" 
                        @click="editItem('name' + item.id,'edit' + item.id,'save' + item.id)"
                      ></span>

                     


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Class Form -->
            <div class="container bg-light-blue">
              <div class="row klas-list input-part">
                <div class="col col-1 no-pad"></div>
                <div class="col col-11 no-pad">
                  <h4><span>+</span> Voeg een klas toe:</h4>
                  <div class="row no-mar">
                    <div class="col col-5 no-pad">
                      <p>Klasnaam</p>
                    </div>
                    <div class="col col-7 no-pad">
                      <p>Selecteer onderwijstype</p>
                    </div>
                  </div>
                  <div class="row no-mar">
                    <div class="col col-5 no-pad">
                      <input
                        type="text"
                        v-model="newItem"
                        class="form-control new-klas"
                      />
                      <br />
                      <p class="error">{{ msgValid }}</p>
                    </div>
                    <div class="col col-7 no-pad">
                      <label class="radio-container">
                        <input type="radio" v-model="newType" value="praktisch" />
                        <span class="checkmark"></span>
                        Praktisch
                      </label>
                      <label class="radio-container">
                        <input
                          type="radio"
                          v-model="newType"
                          value="theoretisch"
                        />
                        <span class="checkmark"></span>
                        Theoretisch
                      </label>
                    </div>
                  </div>
                  <div class="row no-mar">
                    <div class="col col-12 no-pad">
                      <div class="input-group-btn">
                        <button
                          class="btn btn-secondary hvr-border-fade"
                          :class="{ 'btn-primary': newItem }"
                          @click="addItem"
                        >
                          Opslaan
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- License Usage -->
            <div class="container bg-blue padding-bold">
              <div class="row klas-list">
                <div class="col col-1 no-pad"></div>
                <div class="col col-11 no-pad licence">
                  
                  <div v-if="loading">
                    <p>Loading license data...</p>
                  </div>
                  <div v-else>
                    <p>
                      {{ todos || 0 }} van de {{ nol || 0 }} School Licenties gebruikt
                    </p>
                    <ul>
                      <li
                        v-for="index in nol"
                        :key="'license-' + index"
                        :class="{
                          used: todos >= index,
                          'my-used-class': index <= items.length
                        }"
                      >
                        <!-- Add any content you want inside the <li> -->
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"; // Import Vue
import axios from "axios"; // Import Axios if used outside Vue prototype

export default {
  name: "Tijdslijn",
  data() {
    return {
      items: [],
      newItem: "",
      newType: "",
      todos: 0,
      nol: 0,
      loading: true,
      msgValid: "",
      parentIDVar: localStorage.getItem("parentID"),
    };
  },
  async created() {
    try {
      console.log("Initializing data...");
      await this.loadData();
    } catch (error) {
      console.error("Error during data fetching:", error);
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.matchHeight();
  },
  methods: {
    /**
     * Loads all required data.
     */
    async loadData() {
      await this.fetchClasses();
      await this.getFirstClass();
      await this.getNumOfLes();
      await this.getNumOfAllClassesOfSchool();
    },

    /**
     * Sets the height of `.nav-side` to match the height of `#componentBox`.
     */
    matchHeight() {
      const componentBox = document.getElementById("componentBox");
      if (componentBox) {
        const height = componentBox.offsetHeight;
        const navSide = document.querySelector(".nav-side");
        if (navSide) {
          navSide.style.height = `${height}px`;
        }
      }
    },

    /**
     * Fetches all classes for the logged-in user.
     */
    async fetchClasses() {
      try {
        const response = await axios.get(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes`,
          {
            params: { author: localStorage.getItem("userID"), per_page: 100 },
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );


        this.items = response.data || [];
        console.log(`You have ${this.items.length} classes.`);// my classes
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    },

    /**
     * Fetches the first class for the logged-in user.
     */
    async getFirstClass() {
      try {
        const response = await axios.get(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes`,
          {
            params: { author: localStorage.getItem("userID"), per_page: 1 },
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        if (response.data && response.data.length > 0) {
          console.log(`First class ID: ${response.data[0].id}`);
        }
      } catch (error) {
        console.error("Error fetching the first class:", error);
      }
    },

    /**
     * Fetches the total number of licenses (nol).
     */
    async getNumOfLes() {
    try {
      /* 1. fetch parent e-mail via the new lightweight route */
      const { data } = await axios.get(
        `${Vue.prototype.$hostname}/wp/wp-json/custom/v1/usermail/${this.parentIDVar}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      /* 2. look up the matching school CPT exactly as before */
      const { data: schools } = await axios.get(
        `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/schools`,
        {
          params: {
            meta_key: "schoolEmail",
            meta_value: data.user_email,
            per_page: 1,
          },
        }
      );

      if (schools && schools.length) {
        this.nol = Number(schools[0].numberClasses);
        localStorage.setItem("numberOfLicences", this.nol);
        console.log(`Number of licenses: ${this.nol}`);
      }
    } catch (err) {
      console.error("Error fetching number of licenses:", err);
    }
  },

    /**
     * Fetches the total number of all classes for the school.
     */
    async getNumOfAllClassesOfSchool() {
      try {
        const response = await axios.get(
          `${Vue.prototype.$hostname}/wp/wp-json/custom/v1/classes-by-parent/`,
          {
            params: { parent_id: this.parentIDVar },
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        if (response.data && response.data.total_classes !== undefined) {
          this.todos = response.data.total_classes;
          localStorage.setItem("numberOfClasses", this.todos);
        } else {
          console.warn("Unexpected response structure:", response.data);
          this.todos = 0;
        }
        console.log(`Number of used classes by my school: ${this.todos}`);
      } catch (error) {
        console.error("Error fetching all classes for the school:", error);
      }
    },

    /**
     * Adds a new class.
     */
    async addItem() {
      if (!this.newItem || !this.newType) {
        this.msgValid = "Klasnaam en onderwijstype zijn verplicht.";
        return;
      }
      if (this.nol <= this.todos) {
        alert(
          "Het maximale aantal licenties is bereikt. Neem contact op met uw interne coördinator."
        );
        return;
      }
      try {
        const content = { title: this.newItem, onderwijstype: this.newType, status: "publish" };
        const response = await axios.post(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes`,
          content,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        this.items.push(response.data);
        this.todos += 1;
        localStorage.setItem("numberOfClasses", this.todos);
        console.log("Class added:", response.data);
        this.newItem = "";
        this.newType = "";
        this.msgValid = "";
      } catch (error) {
        console.error("Error adding class:", error);
      }
    },

    /**
     * Deletes an existing class.
     */
    async deleteItem(index, classID) {
      try {
        await axios.delete(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes/${classID}`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        this.items.splice(index, 1);
        this.todos -= 1;
        localStorage.setItem("numberOfClasses", this.todos);
        console.log("Class deleted:", classID);
      } catch (error) {
        console.error("Error deleting class:", error);
      }
    },

    /**
     * Enables editing of a class name.
     */
    /*
    editItem(ref) {
      const textEl = this.$refs[ref]?.[0];
      if (textEl) {
        textEl.contentEditable = true;
        textEl.classList.add("active");
      }
    },
*/
    editItem(ref,refedit,refsave){
        
                  
          var textEl = this.$refs[ref]?.[0];
          textEl.contentEditable = true;
          textEl.classList.add("active");
          //console.log(this.$refs[ref][0]);  

          var editBut = this.$refs[refedit]?.[0];
          editBut.style.display = 'none';
          //console.log(this.$refs[refedit][0]);

          var saveBut = this.$refs[refsave]?.[0];
          saveBut.style.display = 'inline-block';
          //console.log(this.$refs[refsave][0]);

        },


    /**
     * Updates an existing class.
     */
    async updateItem(ref, item, refedit, refsave) {
      const textEl = this.$refs[ref]?.[0];
      if (!textEl) return;

      try {
        const updatedContent = { title: textEl.textContent.trim() };
        const response = await axios.put(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes/${item.id}`,
          updatedContent,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        item.title.rendered = response.data.title.rendered;
        textEl.contentEditable = false;
        textEl.classList.remove("active");

        var editBut = this.$refs[refedit]?.[0];
              editBut.style.display = 'inline-block';

              var saveBut = this.$refs[refsave]?.[0];
              saveBut.style.display = 'none';


        console.log("Class updated:", response.data);
        localStorage.setItem("changedName",1);
      } catch (error) {
        console.error("Error updating class:", error);
      }
    },

    /**
     * Handles input changes while editing.
     */
    handleInput(event) {
      this.content = event.target.innerHTML;
    },
  },
};
</script>

<style scoped>
.error{
  height: 20px;
  color: #f00;
  font-weight: 600;
}
div.licence ul li.my-used-class{
opacity: 0.25 !important;
}

</style>